var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"pa-6"},[_c('Header',{on:{"menu-toggled":function($event){_vm.menuIsOpen = $event}}}),_c('Sidebar',{attrs:{"menu-is-open":_vm.menuIsOpen}}),_c('v-main',{staticClass:"content"},[_c('router-view'),_c('Footer',{staticStyle:{"display":"flex","align-items":"end","position":"absolute","bottom":"0"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }